import type { SnapshotFrom } from 'xstate'
import type multiCartMachine from './multiCartMachine'

export type MultiCartSnapshot = SnapshotFrom<typeof multiCartMachine>

export const selectItemsInActiveCart = (snapshot: MultiCartSnapshot): Array<App.MultiCartItem> => {
  const { cartItems, activeCartId } = snapshot.context
  if (cartItems.status !== 'loaded' || !activeCartId) return []
  return Object.values(cartItems.data[activeCartId] ?? {})
}
